// extracted by mini-css-extract-plugin
export default {"card":"CardServices_card__asBJl","flipped":"CardServices_flipped__pBkDA","side":"CardServices_side__NAer8","front":"CardServices_front__7SLy3","back":"CardServices_back__-bEnr"};